import {Component, Input, Output, EventEmitter, OnInit} from '@angular/core';
import { MessageService } from 'primeng/api';
import {UserTableSettingsService} from '../../services/user-table-settings.service';
import {EditTableConfig} from '../../models/configs/edit-table-config';

@Component({
    providers: [MessageService],
    selector: 'column-selector',
    template: `
<p-sidebar [(visible)]="showRearrangeSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           [style]="{width:'580px'}">
    <ng-template pTemplate="header">Rearrange Table</ng-template>
    <div class="mt-4 mb-4 common-header-font">Rearrange Header</div>

    <button class="btn-darkblue btn-reset" pButton label="Reset Order" (click)="resetColumnOrder()"></button>
    <button class="btn-darkblue btn-reset p-3 mt-4" pButton label="Check/Uncheck All" (click)="checkUncheckAll()"></button>

    <div class="rearrange-items mb-2" pDraggable="dr" pDroppable="dr" *ngFor="let item of columns; let ind = index"
         (onDragStart)="dragStart(item, ind)" (onDragEnd)="dragEnd()" (onDrop)="drop(ind)">
        {{item.header}}
        <div class="mr-3 flex-row">
            <p-checkbox class="mr-3 mb-13" [binary]="true" [(ngModel)]="item.active" (onChange)="rearrangeColumnChecked(item, $event)" inputId="item.header"></p-checkbox>
            <img class="rearrange-icon" src="../Content/xpress-app/images/rearrange-icon.svg"/>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end mt-4">
            <button class="btn-darkblue" pButton label="Apply" (click)="saveTableSettings()"></button>
        </div>
    </ng-template>
</p-sidebar>

<button class="rearrange-btn" [ngStyle]="{ height: btnHeight + 'px', width: btnWidth + 'px', }" pButton label="Rearrange Table" (click)="swapRearrangeSidebar()"></button>
    `,
    styleUrls: ['./column-selector.component.scss']
})
export class ColumnSelectorComponent implements OnInit {

    @Input()
    public tableName: string = EditTableConfig.NONE;

    @Input()
    public columns: any[] = [];

    @Input()
    public selectedColumns: any[] = [];

    @Input()
    public defaultColumns: any[] = [];

    @Input()
    public btnHeight: number = 36;

    @Input()
    public btnWidth: number = 155;

    @Output()
    public selectedColumnsChange = new EventEmitter<any[]>();

    public showRearrangeSidebar: boolean = false;
    public checkAll: boolean = true;

    draggedBlock = null;
    startInd: number = 0;

    constructor(
        private messageService: MessageService,
        private userTableSettings: UserTableSettingsService) {
    }

    ngOnInit(): void {
        this.resetColumnOrder();
        this.loadTableSettings();
    }

    swapRearrangeSidebar() {
        this.showRearrangeSidebar = !this.showRearrangeSidebar;
    }

    rearrangeColumnChecked(item: any, event: any){
        this.columns.find(x => x.field === item.field).active = event.checked;
    }

    resetColumnOrder() {
        this.columns = this.defaultColumns.map(x => x);
        for (const col of this.columns) {
            col.active = true;
        }
    }

    checkUncheckAll() {
        for (const col of this.columns) {
            col.active = this.checkAll;
        }
        this.checkAll = !this.checkAll;
    }

	addNewColumns(savedColumns: any[]): any[] {
		const newColumns = this.defaultColumns
			.filter(
				(defaultColumn) =>
					!savedColumns.some(
						(savedColumn) => savedColumn.field === defaultColumn.field
					)
			)
			.map((newColumn) => ({ ...newColumn, active: false }));

		if (newColumns.length > 0) {
			return [...savedColumns, ...newColumns];
		}

		return savedColumns;
	}

    loadTableSettings(tableName: string = '') {
        const table = !tableName ? this.tableName : tableName;
        const request = {
            TableName: table
        };
        this.userTableSettings.GetUserTableSettings(request, this.messageService)
            .then(data => {
                if (data.Success) {
                    if (data?.TableSettings?.SelectedColumns) {
                        const savedColumns = JSON.parse(data.TableSettings.SelectedColumns);
                        if (Array.isArray(savedColumns) && savedColumns.length) {
                            this.selectedColumns = savedColumns.filter(x => x.active);
                            this.columns = this.addNewColumns(savedColumns);
                        }
                    }
                    else {
                        this.columns = this.defaultColumns.map(x => x);
                        this.selectedColumns = this.defaultColumns.map(x => x);
                        for (const col of this.selectedColumns) {
                            col.active = true;
                        }
                    }

                    this.selectedColumnsChange.emit(this.selectedColumns);
                } else {
                    this.messageService.add({severity: 'error', summary: 'Error', detail: data.ErrorMessage});
                }
            });

    }

    saveTableSettings() {
        const request = {
            TableName: this.tableName,
            SelectedColumns: JSON.stringify(this.columns)
        };
        this.userTableSettings.SaveUserTableSettings(request, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                }
                else {
                    this.selectedColumns = this.columns.filter(x => x.active);
                    this.selectedColumnsChange.emit(this.selectedColumns);
                }
            });
    }

    dragStart(block: any, ind: number) {
        this.draggedBlock = block;
        this.startInd = ind;
    }

    dragEnd() {
        this.draggedBlock = null;
    }

    drop(ind: number) {
        this.columns.splice(this.startInd, 1);
        this.columns.splice(ind, 0, this.draggedBlock);
    }
}
